<template>
    <div ref="map" id="map"></div>
</template>

<script>

    import {CustomMarker, MarkerClusterer, MarkerTooltip} from './search'
    import _map from 'lodash/map'
    import _pick from 'lodash/pick'
    import _each from 'lodash/each'
    import _isNull from 'lodash/isNull'
    import _throttle from 'lodash/throttle'
    import _isMatchWith from 'lodash/isMatchWith'
    import _isObject from 'lodash/isObject'
    import _isNumber from 'lodash/isNumber'
    import _intersection from 'lodash/intersection'
    import _has from 'lodash/has'
    import {MapEventHub} from './search/MapEventHub'
    import PropertyMixin from './search/mixin.property.vue'

    window.isMatchWith = _isMatchWith;

    export default {
        // components: {PropertyDetails, GoogleMapTooltip},
        mixins: [PropertyMixin],
        props: {
            locations: {
                type: Array,
                default: () => {return []}
            },
            mapCenter: {
                type: Object,
                default: {
                    lat: 27.8484901,
                    lng: -79.613978
                }
            },
            filters: {
                type: Object,
                default: {}
            },
        },
        data() {
            return {
                response: null,
                posts: [],
                loaded: false,
                markers: null,
                markerCluster: null,
                tooltipContent: '',
                setInitialBounds: true,
                mappedMarkers: {},
                property: null,
                pinHovered: false,
            }
        },
        computed: {
            propertyName() {
                return this.property && this.property.title
                    && this.property.title.rendered;
            },
            activeProperty() {
                return MapEventHub.activeProperty;
            },
            isMobile() {
                return MapEventHub.isMobile;
            },
        },
        watch: {
            filters: {
                deep: true,
                handler() {
                    this.$nextTick(() => {
                        this.throttledSetMarkerVisibility();
                    });
                }
            },
            propertyTitle() {
                this.tooltipContent = `<div class="property-item map-hover-tooltip">
                        <div class="padding-wrapper">
                            <div class="col-1" style="background-image: url(${this.imageUrl})">
                            </div>
                            <div class="col-2">
                                <div class="property-body">
                                    <h4 class="property-title">${this.propertyTitle}</h4>
                                    <address class="address">${this.propertyAddress}</address>
                                    <div class="property-type">${this.propertyTypes}</div>
                                    <div class="wrap-price">
                                        <div class="property-amenities">${this.propertyAmenities}</div>
                                        <div class="property-price">${this.propertyFromPrice}</div>
                                    </div>
                                </div>
                                <div class="availability"></div>
                            </div>
                        </div>
                        <a href="${this.propertyUrl.url}" class="link-cta">View Property</a>
                    </div>`;

                    this.tooltip.setContent(this.tooltipContent);
            },
            activeProperty: {
                deep: true,
                immediate: true,
                handler(property, oldProperty) {
                    if (property && property.id) {
                        this.$nextTick(() => {
                            //set mixin value
                            this.property = property;


                            if (property && property.id) {

                                let activeMarker = this.mappedMarkers[property.id];
                                activeMarker.customPin.addClass('pin-hover');


                                if (MapEventHub.hoverType === 'list') {
                                    this.map.panTo(activeMarker.getPosition());

                                    if (MapEventHub.isMobile)
                                        this.map.panBy(window.innerWidth / 4, 0);
                                    else
                                        this.map.panBy(-window.innerWidth / 8, 0);
                                }

                                this.tooltip.open(this.map, activeMarker);
                            }
                            else {
                                MapEventHub.hoverType = '';
                            }
                        });
                    }
                }
            }

        },
        mounted() {
            window.timer = null;
            this.createMap();
            this.tooltip = new MarkerTooltip();
        },
        methods: {
            createMap: function () {
                this.map = new google.maps.Map(this.$refs.map, {
                    center: this.mapCenter,
                    zoom: 10,
                    mapTypeControl: false,
                    streetViewControl: false,
                    fullscreenControl: false,
                    zoomControlOptions: {
                        position: google.maps.ControlPosition.RIGHT_CENTER,
                    },
                    styles: [
                        {
                            featureType: "poi",
                            stylers: [
                                { visibility: "off" }
                            ]
                        }
                    ],
                    minZoom: 3,
                    maxZoom: 18
                });

                // set default properties to all
                MapEventHub.filteredProperties = this.locations;


                this.$nextTick(() => {
                    this.setLocations();

                })
            },

            setLocations() {
                // Create markers
                let self = this;

                this.map.addListener('drag', function() {
                    self.tooltip.close();
                });

                this.markers = _map(this.locations, (location) => {

                    let coordinates = _pick(location.acf.location, 'lat', 'lng');

                    location.units = 1;

                    let marker = new google.maps.Marker({
                        id: location.id,
                        name: location.title.rendered,
                        filters: {
                            amenities: _map(location.acf.amenities_list, (amenity) => { return amenity.value} ),
                            state: location.acf.state.value, // String
                            city: location.acf.city, // String
                            beds: location.acf.apartment_types || [],// ['studio', 1,2,3,4]
                            baths: location.acf.bathrooms || [],// [1,2,3,4]
                            price: {
                                min: location.acf.price_range_min || 0,
                                max: location.acf.price_range_max || 0
                            },
                            date: 0,
                            zip: location.acf.zip
                        },
                        property: location,
                        position: {
                            lat: parseFloat(coordinates.lat),
                            lng: parseFloat(coordinates.lng)
                        },
                        mappedMarkers: {},
                        map: this.map,
                        icon: '/wp-content/plugins/razz-real-estate-search-tool/assets/images/marker.png'// hide pin image
                    });


                    // foreach marker create a custom marker (orange Pin)
                    marker.customPin = new CustomMarker(location.id, marker.position, this.map, {marker});

                    marker.addListener('mouseover', () => {
                        if (window.timer > 0) {
                            clearTimeout(window.timer);
                            clearInterval(window.timer);
                        }

                        if (self.property && marker.property.id === self.property.id)
                            self.tooltip.initMouseEvents();
                        else
                            self.tooltip.close();

                        self.property = marker.property;
                        MapEventHub.activeProperty = marker.property;
                        MapEventHub.hoverType = 'pin';

                        if (marker.map) {
                            self.tooltip.url = self.propertyUrl;
                            self.tooltip.open(self.map, marker);
                        }

                        marker.customPin.addClass('pin-hover');
                    });

                    marker.addListener('mouseout', () => {
                        clearTimeout(window.timer);
                        clearInterval(window.timer);

                        window.timer = setTimeout(() => {
                            self.tooltip.close();
                        }, 1000);

                        marker.customPin.removeClass('pin-hover');

                    });

                    // add event listener for custom marker
                    marker.addListener('click', function () {
                        self.map.panTo(marker.getPosition());

                        self.property = marker.property;
                        MapEventHub.activeProperty = marker.property;
                        MapEventHub.hoverType = 'pin';
                    });

                    this.mappedMarkers[location.id] = marker;

                    return marker;
                });

                MapEventHub.mappedMarkers = this.mappedMarkers;

                this.redrawCluster();

                this.$emit('mapLoaded');
            },
            throttledSetMarkerVisibility() {
                MapEventHub.idle = true;
                if (!this._throttledSetMarkerVisibility) {
                    this._throttledSetMarkerVisibility = _throttle(this.setMarkerVisibility, 300);
                }

                this._throttledSetMarkerVisibility();
            },
            setMarkerVisibility() {

                MapEventHub.resetFilteredProperties();

                let self = this;

                _each(self.markers, (marker) => {

                    let counter = 0;
                    let date = new Date();

                    let filters = {
                        amenities: _map(marker.property.acf.amenities_list, (amenity) => { return amenity.value} ),
                        state: marker.property.acf.state.value, // String
                        city: marker.property.acf.city, // String
                        beds: self.convertToFloat(marker.property.acf.apartment_types) || [],// ['studio', 1,2,3,4]
                        baths: self.convertToFloat(marker.property.acf.bathrooms) || [],// [1,2,3,4]
                        price: {
                            min: +marker.property.acf.price_range_min || 0,
                            max: +marker.property.acf.price_range_max || 0
                        },
                        date: date || 0,
                        zip: marker.property.acf.zip
                    };


                    if ( self.matchesFilter(filters) )
                        counter++;

                    const resultMap = counter > 0 ? self.map : null;

                    marker.customPin.setMap(resultMap);
                    marker.setMap(resultMap);
                    marker.property.units = counter;

                    if ( counter > 0 )
                        MapEventHub.filteredProperties.push(marker.property);
                });

                this.$nextTick(() => {
                    MapEventHub.idle = false;
                });

                this.redrawCluster();
            },
            redrawCluster() {

                let bounds = new google.maps.LatLngBounds();
                let counter = 0;
                let boundsPadding = this.isMobile ? 0 : 150;

                _each(this.markers, (marker) => {
                    if (marker.map) {
                        counter++;
                        bounds.extend(marker.getPosition());
                    }
                });

                if (counter > 0)
                    this.map.fitBounds(bounds, boundsPadding);
            },
            matchesFilter(markerFilters) {
                return _isMatchWith(markerFilters, this.filters, (markerFilter, searchFilter) => {

                    // check if Null or emptyString (reason studio filter == 0)
                    if ( _isNull(searchFilter) || searchFilter < 0 || searchFilter === '' )
                        return true;

                    if (searchFilter === "All" || searchFilter === "*") {
                        return true;
                    }

                    if ( Array.isArray(searchFilter) && searchFilter.length === 0 ) {
                        return true;
                    }

                    let response = false;
                    let dateInput = Date.parse(searchFilter);

                    if ( _isObject(markerFilter) && _has(markerFilter, 'min') && _has(markerFilter, 'max') ) {
                        response = (markerFilter.min >= searchFilter[0] && markerFilter.max <= searchFilter[1] );
                    }
                    else if ( Array.isArray(markerFilter) ) {
                        if ( Array.isArray(searchFilter)) {
                            response = _intersection(searchFilter, markerFilter).length > 0
                        }
                        else
                            response = markerFilter.includes(+searchFilter);
                    }
                    else if ( dateInput && !_isNumber(parseFloat(searchFilter)) ) {
                        response = Date.parse(markerFilter) <= dateInput;
                    }
                    else {
                        response = `${markerFilter}` === `${searchFilter}`;
                    }

                    return response;
                });
            },
            convertToFloat(elements) {
                if ( !elements || !elements.length )
                    return [];

                return elements.map( (el) => {
                    return parseFloat(el);
                })
            }
        }
    }
</script>

<style lang="scss" type="text/scss" scoped>
    #map {
        box-shadow: rgba(0, 0, 0, 0.15) 0 0 15px;
        width: 100%;
        height: 100%;
        min-height: 100vh;

        @media screen and (max-height: 500px) {
            min-height: 500px;
        }

    }
</style>

<style lang="scss" type="text/scss">

    .map-placeholder {
        background: #F3F3F3;
        width: 100%;
        min-height: 100vh;
        height: 100%;
    }

    #map {
        .map-cluster {
            animation: pulse 2s infinite;
            background: $theme-green;
            border-radius: 50%;
            color: #fff;
            display: block;
            height: 50px;
            padding: 0;
            font-family: inherit;
            font-size: 16px;
            line-height: 50px;
            width: 50px;
        }
        .marker-pin {
            position: relative;
            width: 25px;
            height: 20px;

            svg {
                fill: $theme-green;
                position: relative;
                left: 0;
                bottom: -5px;
                transition: all 0.3s ease-in-out 0s;
                transform-origin: 50% 100%;

                &.svg-pulse {
                    display: none;
                    top: 5px;
                    position: absolute;
                    -webkit-animation: svg-pulse 2s infinite;
                    animation: svg-pulse 2s infinite;
                }
            }

            &.pin-hover {

                svg {
                    fill: $blueLight;
                    transform: scale(1.5);
                }
            }
        }
    }

    .map-info-parent {
        pointer-events: none;
    }

    .map-info-window {
        box-shadow: 0 0 25px rgba(0,0,0,0.5);
        background: #fff;
        border-radius: 4px;
        max-width: 300px;
        width: 100%;
        padding: 12px 10px;
        transform: translate(-10px, -20px);
        position: relative;
        z-index: 999;
        pointer-events: all;

        .place-name {
            white-space: nowrap;
        }
    }

    .map-hover-tooltip {
        font-family: $font-family-body;


        .padding-wrapper {
            padding: 0 5px;
        }

        .col-1 {
            min-height: 120px;
            width: 100%;
            background-size: cover;
            background-position: center;
        }
        img {
            max-width: 100%;
        }

        .property-title {
            font-family: $font-family-body;
            color: #212121;
            margin-bottom: 0;
            margin-top: 15px;
            font-size: 20px;
        }

        address.address, .property-type {
            font-style: normal;
            font-size: 12px;
            line-height: 20px;
            color: #808080;
            letter-spacing: 0;
        }

        .property-image {
            max-width: 100%;
            height: auto;
        }

        .property-price {
            color: $theme-green;
            font-weight: 700;
            font-size: 14px;
        }

        .wrap-price {
            display: flex;
            justify-content: space-between;
            width: 100%;
        }

        .property-item {
            margin-bottom: 25px;
            position: relative;
            overflow: hidden;

            .overlay {
                background-color: rgba(#EE811F, .9);
                color: #fff;
                position: absolute;
                width: 100%;
                height: 100%;
                top: 0;
                left: 0;
                opacity: 0;
                pointer-events: none;
                transition: all .3s ease-in-out;

                div {
                    position: absolute;
                    width: calc(100% - 30px);
                    height: calc(100% - 30px);
                    left: 15px;
                    top: 15px;
                    border: 1px solid #fff;

                    span {
                        position: absolute;
                        top: 50%;
                        transform: translateY(-50%);
                        text-align: center;
                        width: 100%;
                    }
                }
            }

            &:hover {
                .overlay {
                    opacity: 1;
                    pointer-events: all;
                }
            }
        }

        .availability {
            text-align: center;
            font-size: 13px;
            color: $blueLight;
            border-bottom: 2px solid;
            padding-bottom: 5px;
        }

        .link-cta {
            display: block;
            background-image: linear-gradient(to bottom, $theme-green 0%, $theme-green 50%, $theme-green 100%);
            width: 100%;
            color: #fff;
            box-shadow: none;
            border: 0;
            border-radius: 0;
            height: 40px;
            cursor: pointer;
            transition: all .3s ease-in-out;
            text-align: center;
            line-height: 25px;
            margin-top: 10px;
            text-decoration: none;
            font-weight: 300;
            padding: 8px;


            &:hover {
                opacity: .8;
            }
        }
    }


    @-webkit-keyframes svg-pulse {
        0% {
            transform: scale(1);
            opacity: 1;
        }
        50% {
            opacity: 0.3;
        }
        100% {
            transform: scale(1.7);
            opacity: 0;
        }
    }

    @keyframes svg-pulse {
        0% {
            transform: scale(1);
            opacity: 1;
        }
        50% {
            opacity: 0.3;
        }
        100% {
            transform: scale(1.7);
            opacity: 0;
        }
    }
</style>